var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-dropdown",
    {
      ref: "dropdown",
      attrs: {
        label: _vm.label,
        "label-loading": _vm.labelLoading,
        heading: _vm.heading,
        disabled: _vm.disabled,
        styles: _vm.styles,
      },
      on: { open: _vm.open },
    },
    [
      _c(
        "template",
        { slot: "dropdownToggler" },
        [
          _vm.tooltip
            ? _c(
                "b-tooltip",
                {
                  attrs: {
                    type: "is-dark",
                    label: _vm.tooltip,
                    position: _vm.tooltipPlacement,
                    animated: "",
                  },
                },
                [
                  _vm._t("default"),
                  _vm._v(" "),
                  _vm.iconSuffix !== null
                    ? _c("fa", {
                        staticClass: "iconSuffix",
                        attrs: { icon: _vm.iconSuffix },
                      })
                    : _vm._e(),
                ],
                2
              )
            : _vm._t("default"),
          _vm._v(" "),
          _vm.iconSuffix !== null
            ? _c("fa", {
                staticClass: "iconSuffix",
                attrs: { icon: _vm.iconSuffix },
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("template", { slot: "dropdownContent" }, [
        _vm.search === true
          ? _c("div", { staticClass: "user-search" }, [
              _c("div", { staticClass: "search-bar" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchTerm,
                      expression: "searchTerm",
                    },
                  ],
                  staticClass: "search-bar-input",
                  attrs: { type: "text", placeholder: "Search..." },
                  domProps: { value: _vm.searchTerm },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchTerm = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "search-icon-container" },
                  [
                    _c("fa", {
                      staticClass: "search-icon",
                      attrs: { icon: "search" },
                    }),
                  ],
                  1
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "item-list", style: _vm.styles },
          [
            _vm._l(_vm.filteredResults, function (item) {
              return [
                item.separator === true
                  ? [
                      _c(
                        "div",
                        {
                          directives: [
                            { name: "tooltip", rawName: "v-tooltip" },
                          ],
                          staticClass: "seperator",
                          attrs: { title: _vm._f("title")(item.title) },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.label) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(item.items, function (subItem) {
                        return _c(
                          "div",
                          {
                            directives: [
                              { name: "tooltip", rawName: "v-tooltip" },
                            ],
                            staticClass: "item",
                            attrs: { title: _vm._f("title")(subItem.title) },
                            on: {
                              click: function ($event) {
                                return _vm.itemSelected(subItem, item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(subItem.label) +
                                "\n            "
                            ),
                            subItem.copyValue
                              ? _c("fa", {
                                  staticClass: "copy",
                                  attrs: { icon: "copy" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$copyText(subItem.copyValue)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                    ]
                  : item.items
                  ? _c(
                      "div",
                      {
                        directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                        staticClass: "item",
                        attrs: { title: _vm._f("title")(item.title) },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(item.label) + "\n          "
                        ),
                        _c(
                          "div",
                          { staticClass: "item-chevron" },
                          [_c("fa", { attrs: { icon: "chevron-right" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "perfect-scrollbar",
                          { staticClass: "item-list sub-list" },
                          _vm._l(item.items, function (subItem) {
                            return _c(
                              "div",
                              {
                                staticClass: "item",
                                on: {
                                  click: function ($event) {
                                    return _vm.itemSelected(subItem, item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(subItem.label) +
                                    "\n              "
                                ),
                                subItem.copyValue
                                  ? _c("fa", {
                                      staticClass: "copy",
                                      attrs: { icon: "copy" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$copyText(
                                            subItem.copyValue
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    )
                  : item.value !== "default" && _vm.$slots[item.value]
                  ? _c("div", { staticClass: "item" }, [_vm._t(item.value)], 2)
                  : _c(
                      "div",
                      {
                        directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                        staticClass: "item",
                        attrs: { title: _vm._f("title")(item.title) },
                        on: {
                          click: function ($event) {
                            return _vm.itemSelected(item)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.labelAs ? item[_vm.labelAs] : item.label
                            ) +
                            "\n          "
                        ),
                        item.copyValue
                          ? _c("fa", {
                              staticClass: "copy",
                              attrs: { icon: "copy" },
                              on: {
                                click: function ($event) {
                                  return _vm.$copyText(item.copyValue)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
              ]
            }),
          ],
          2
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }